var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophoneDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.4589 19.591c.3518-.9022.5411-1.9221.5411-3.0327v-1.0996c0-.4343-.3224-.7758-.7325-.7758-.4133 0-.7451.3415-.7451.7758v1.0374c0 .6878-.0827 1.3303-.2405 1.9191z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.9102 22.7416-1.0714-1.07c-.8004.4465-1.7558.689-2.8325.689-3.356 0-5.5287-2.3377-5.5287-5.8645v-1.0374c0-.4343-.3224-.7758-.74192-.7758-.41324 0-.73568.3415-.73568.7758v1.0996c0 4.0544 2.5358 6.8988 6.2612 7.2298v1.6805l.0022.7958c.0011.4066.3311.7356.7377.7356.4074 0 .7377-.3303.7377-.7377v-2.4742c1.1957-.1059 2.2671-.469 3.1714-1.0465z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.9992 17.1338c.0005-.0303.0008-.0607.0008-.0913v-8.0847c0-2.33976-1.6046-3.9578-3.9923-3.9578-2.3992 0-4.0077 1.61804-4.0077 3.9578v.18491z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 14.8421v2.2004c0 2.3286 1.6085 3.9575 4.0077 3.9575.6662 0 1.2714-.1268 1.7979-.3602z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m26.3837 27.7231c.3702.3692.9728.3692 1.343 0 .3585-.3819.3703-.9729 0-1.3425l-22.107-22.10339c-.36629-.36961-.96886-.36961-1.35089 0-.35841.36923-.35841.98513 0 1.34213z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneDisabled);
export default __webpack_public_path__ + "static/media/Microphone_Disabled.7615c51bf487c55a007f8fc6b8a9945f.svg";
export { ForwardRef as ReactComponent };